import { render } from "./EditUsers.vue?vue&type=template&id=78b1a11a"
import script from "./EditUsers.vue?vue&type=script&lang=js"
export * from "./EditUsers.vue?vue&type=script&lang=js"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__